import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import * as Sentry from "@sentry/react";
const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [

      Sentry.browserTracingIntegration(),
      //Sentry.replayIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    ],
    tracesSampleRate: 1.0, 
   // replaysSessionSampleRate: 0.1, 
   // replaysOnErrorSampleRate: 1.0, 
    environment: import.meta.env.MODE,
    enableLogs: true,
    sendDefaultPii: true,
    
  });
  console.log('Sentry initialized correctly');
} else {
  console.log('Sentry not configured (no DSN)');
}

createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
